import { useState } from "react";
import { Link } from "react-router-dom";
import { useGetClueWithoutActivity } from "../../hooks/useCrm";
import PersonalInfo from "../../pages/PersonalInfo/PersonalInfo";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import Loading from "../Loadings/LoadingTable";
import { Table } from "../Table/Table";
import { UsersListStyle } from "./UsersListStyle";

const UsersList = () => {
  return (
    <UsersListStyle className="mt-3">
      <PersonalInfo scroll CrmUsers={true} />
    </UsersListStyle>
  );
};

export default UsersList;
